// Core
import React, { useState, useEffect } from "react";
import axios from "axios";

// CSS
import "./categories.css";

// Images
import Plus from "../picture/Plus.png";
import Edit from "../picture/edit.png";
import Check from "../picture/check.png";
import Plane from "../picture/plane.png";
import DeleteIcon from "../picture/close.png";

function Categories({ setActiveCategoriesScreen,location }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [editingCategoryId, setEditingCategoryId] = useState(null); // Currently editing category ID
  const [editingCategoryName, setEditingCategoryName] = useState(""); // Name of the category being edited
  const [addingCategory, setAddingCategory] = useState(false); // PLUS button clicked
  const [selectedColor, setSelectedColor] = useState(null); // Currently selected color
  const [categoryName, setCategoryName] = useState(""); // Current category name

  // Form states for adding a new category
  const [newCategoryName, setNewCategoryName] = useState("");
  const [newCategoryColor, setNewCategoryColor] = useState("#ffffff");
  const [creating, setCreating] = useState(false);

console.log(location)

  let locationId = location.location_input;
  let apiKey =
    "c4222563ed7114b9ed64f5bd3120f5cdb1a8aac9f98e7cf7bda1049d54e4c168";
  let user_id = 1;

  // Fetch categories when the component mounts or when locationId changes
  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      setError("");

      try {
        const response = await axios.post(
          "https://data.nadzor.app/api/categories/getAllCats.php",
          { location_id: locationId }
        );

        if (response.data.status === 200) {
          setCategories(response.data.categories);
        } else {
          setError("No categories found");
        }
      } catch (err) {
        setError("Error fetching categories: " + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [locationId]); // Dependency array: fetch when locationId changes

  // Define the available colors for the palette
  const availableColors = [
    "#ff7f2aff",
    "#ff2a2aff",
    "#d40000ff",
    "#00ffffff",
    "#0000ffff",
    "#000080ff",
    "#00ff00ff",
    "#00aa00ff",
    "#005500ff",
    "#f2f200ff",
    "#ffcc00ff",
    "#aa8800ff",
    "#ff00ffff",
    "#6600ffff",
    "#442178ff",
    "#999999ff",
    "#666666ff",
    "#000000ff",
  ];

  const handleToggleActive = async (id, currentStatus) => {
    // Toggle the category's active status
    const newStatus = currentStatus === 1 ? 0 : 1; // If currentStatus is 1, toggle to 0 (inactive), else to 1 (active)

    try {
      // Update the category's active status in the UI immediately
      setCategories(
        categories.map((category) =>
          category.id === id ? { ...category, active: newStatus } : category
        )
      );

      // Now make the API call to update the category's active status in the database
      const response = await axios.post(
        "https://data.nadzor.app/api/categories/updateCatActive.php",
        {
          api_key: apiKey, // Include your API key
          user_id: user_id, // Include your user ID
          category_id: id,
          category_active: newStatus, // Send the correct toggled active status
        }
      );

      if (response.data.status === 200) {
        console.log("Category active status updated successfully!");
      } else {
        alert("Error updating category active status.");
      }
    } catch (err) {
      console.error("Error updating category active status:", err);
      alert("Error updating category active status.");
    }
  };

  const handleAddCategoryClick = () => {
    setAddingCategory(true);
    setSelectedColor(null); // Reset selected color
    setCategoryName(""); // Reset category name
  };

  const handleSelectColor = (color) => {
    if (!addingCategory) {
      alert("Click the PLUS button first to add a category!");
      return;
    }
    setSelectedColor(color);
  };

  // const handleSaveCategory = () => {
  //     if (!selectedColor) {
  //         alert("Please select a color!");
  //         return;
  //     }
  //     if (!categoryName.trim()) {
  //         alert("Please enter a category name!");
  //         return;
  //     }

  //     // Find the smallest missing number
  //     const usedNumbers = categories.map((category) => category.id);
  //     const nextNumber = Array.from({ length: categories.length + 1 }, (_, i) => i + 1).find(
  //         (num) => !usedNumbers.includes(num)
  //     );

  //     // Add the new category and sort the list by `id`
  //     const updatedCategories = [
  //         ...categories,
  //         { id: nextNumber, color: selectedColor, name: categoryName, active: true },
  //     ].sort((a, b) => a.id - b.id); // Sort by `id`

  //     setCategories(updatedCategories); // Update the state with the sorted list
  //     setAddingCategory(false); // Exit adding mode
  //     setSelectedColor(null); // Clear selected color
  //     setCategoryName(""); // Clear category name
  // };
  // const handleSaveCategory = async () => {
  //     if (!selectedColor) {
  //         alert("Please select a color!");
  //         return;
  //     }
  //     if (!categoryName.trim()) {
  //         alert("Please enter a category name!");
  //         return;
  //     }

  //     // Show loading state
  //     setCreating(true);

  //     try {
  //         const response = await axios.post("https://data.nadzor.app/api/categories/createCat.php", {
  //             location_id: locationId,  // assuming locationId is set as 1 or dynamically
  //             category_name: categoryName,
  //             category_color: selectedColor,
  //             user_id: 1,
  //             api_key: "c4222563ed7114b9ed64f5bd3120f5cdb1a8aac9f98e7cf7bda1049d54e4c168"
  //         });

  //         if (response.data.status === 200) {
  //             // Add the newly created category to the categories list
  //             setCategories(prevCategories => [
  //                 ...prevCategories,
  //                 response.data.category,
  //             ]);

  //             // Clear the form and reset states
  //             setCategoryName('');
  //             setSelectedColor(null);
  //             setAddingCategory(false);
  //         } else {
  //             setError('Failed to create category');
  //         }
  //     } catch (err) {
  //         setError('Error creating category: ' + err.message);
  //     } finally {
  //         setCreating(false);  // Reset creating state
  //     }
  // };

  // const handleSaveCategory = async () => {
  //     if (!selectedColor) {
  //         alert("Please select a color!");
  //         return;
  //     }
  //     if (!categoryName.trim()) {
  //         alert("Please enter a category name!");
  //         return;
  //     }

  //     setCreating(true);

  //     try {
  //         const response = await axios.post("https://data.nadzor.app/api/categories/createCat.php", {
  //             location_id: locationId,  // assuming locationId is set as 1 or dynamically
  //             category_name: categoryName,
  //             category_color: selectedColor,
  //             user_id: 1,
  //             api_key: "c4222563ed7114b9ed64f5bd3120f5cdb1a8aac9f98e7cf7bda1049d54e4c168"
  //         });

  //         console.log('API Response:', response.data); // Log the API response

  //         if (response.data.status === 200 && response.data.category) {
  //             // Log the new category data to make sure it's correct
  //             console.log('New Category:', response.data.category);

  //             // Add the newly created category to the categories list
  //             setCategories((prevCategories) => [
  //                 ...prevCategories,
  //                 response.data.category, // Add the new category
  //             ]);

  //             // Clear the form and reset states
  //             setCategoryName('');
  //             setSelectedColor(null);
  //             setAddingCategory(false);
  //         } else {
  //             setError('Failed to create category');
  //         }
  //     } catch (err) {
  //         setError('Error creating category: ' + err.message);
  //     } finally {
  //         setCreating(false);  // Reset creating state
  //     }
  // };

 const handleSaveCategory = async () => {
  if (!selectedColor) {
    alert("Please select a color!");
    return;
  }
  if (!categoryName.trim()) {
    alert("Please enter a category name!");
    return;
  }

  setCreating(true);

  try {
    const response = await axios.post(
      "https://data.nadzor.app/api/categories/createCat.php",
      {
        location_id: locationId,
        category_name: categoryName,
        category_color: selectedColor,
        user_id: user_id,
        api_key: apiKey,
      }
    );

    console.log("Full API Response:", response.data);
    console.log("Category from API:", response.data.category);

    if (response.data.status === 200 && response.data.category) {
      // Add the new category with all required fields
      const newCategory = {
        ...response.data.category,
        name: response.data.category.name || categoryName,
        color: response.data.category.color || selectedColor,
        letter: response.data.category.letter || String.fromCharCode(65 + categories.length), // Generate letter if missing
        active: response.data.category.active !== undefined ? response.data.category.active : 1
      };

      console.log("New category to add:", newCategory);

      setCategories((prevCategories) => {
        const updated = [...prevCategories, newCategory];
        return updated.sort((a, b) => a.id - b.id);
      });

      // Clear the form
      setCategoryName("");
      setSelectedColor(null);
      setAddingCategory(false);
    } else {
      alert("Failed to create category");
    }
  } catch (err) {
    console.error("Error creating category:", err);
    alert("Error creating category: " + err.message);
  } finally {
    setCreating(false);
  }
};

  const handleCancel = () => {
    setAddingCategory(false);
    setSelectedColor(null);
    setCategoryName("");
  };

  const toggleCategoryActive = (id) => {
    setCategories(
      categories.map((category) =>
        category.id === id
          ? { ...category, active: !category.active }
          : category
      )
    );
  };

  const handleDeleteCategory = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this category?"
    );
    if (!confirmDelete) return;

    try {
      // Make the DELETE request to the backend
      const response = await axios.post(
        "https://data.nadzor.app/api/categories/deleteCategory.php",
        {
          api_key: apiKey, // Replace with your actual API key
          user_id: user_id, // Replace with your actual user ID
          category_id: id,
        }
      );

      if (response.data.status === 200) {
        // Remove the category from the local state (UI)
        setCategories(categories.filter((category) => category.id !== id));
        alert("Category deleted successfully!");
      } else {
        alert("Error deleting category");
      }
    } catch (err) {
      console.error("Error deleting category:", err);
      alert("Error deleting category");
    }
  };

  const handleEditCategory = (id, name) => {
    setEditingCategoryId(id);
    setEditingCategoryName(name);
  };

  const handleSaveEdit = async (id) => {
    setCategories(
      categories.map((category) =>
        category.id === id
          ? { ...category, name: editingCategoryName }
          : category
      )
    );
    setEditingCategoryId(null);
    setEditingCategoryName("");

    // Make API call to update category name in the database
    try {
      const response = await axios.post(
        "https://data.nadzor.app/api/categories/updateCat.php",
        {
          api_key: apiKey, // Include API key
          user_id: user_id, // Include user ID
          category_id: id,
          category_name: editingCategoryName,
        }
      );

      if (response.data.status === 200) {
        alert("Category name updated successfully!");
      } else {
        alert("Error updating category name.");
      }
    } catch (err) {
      console.error("Error updating category:", err);
      alert("Error updating category name.");
    }
  };

  const getTextColor = (hexColor) => {
    if (!hexColor) {
      return "black"; // Fallback in case the color is undefined or null
    }

    // Convert HEX to RGB
    const bigint = parseInt(hexColor.replace("#", ""), 16);
    const r = (bigint >> 16) & 255; // Red
    const g = (bigint >> 8) & 255; // Green
    const b = bigint & 255; // Blue

    // Calculate HSP (Highly Sensitive Perception)
    const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

    // If brightness is higher than 150, use black text; otherwise, white
    return hsp > 150 ? "black" : "white";
  };

  const handleDiscardCategories = () => {
    setActiveCategoriesScreen(false);
  };

  const handleSaveCategories = () => {
    setActiveCategoriesScreen(false);
  };

  return (
    <div className="categories-wrapper">
      <div className="title">
        <h2>KATEGORIJE PROCESA</h2>
      </div>
      <div className="categories-layout">
        <div className="categories-list">
          {/* Left Column: First 10 categories */}
          <div className="categories-column">
            {categories.slice(0, 10).map((category) => (
              <div className="category-item" key={category.id}>
                <div
                  className="category-item-mark"
                  style={{
                    background: category.color,
                    color: getTextColor(category.color), // Dynamically set text color
                  }}
                >
                  {category.letter}
                </div>

                <div
                  onClick={() =>
                    handleToggleActive(category.id, category.active)
                  }
                  style={{
                    background: category.active ? "#00b055ff" : "none",
                  }}
                  className="category-item-active"
                >
                  {category.active ? <img src={Check} alt="Active" /> : <></>}
                </div>

                <div className="category-item-name">
                  {editingCategoryId === category.id ? (
                    <input
                      type="text"
                      value={editingCategoryName}
                      onChange={(e) => setEditingCategoryName(e.target.value)}
                      className="category-item-name-input"
                    />
                  ) : (
                    <span>{category.name}</span>
                  )}
                </div>
                <div className="category-item-btns">
                  {editingCategoryId === category.id ? (
                    <button onClick={() => handleSaveEdit(category.id)}>
                      <img src={Check} alt="Save" />
                    </button>
                  ) : (
                    <button
                      onClick={() =>
                        handleEditCategory(category.id, category.name)
                      }
                    >
                      <img src={Edit} alt="Edit" />
                    </button>
                  )}
                  <button onClick={() => handleDeleteCategory(category.id)}>
                    <img src={DeleteIcon} alt="Delete" />
                  </button>
                </div>
              </div>
            ))}

            {/* Adding Form */}
            {addingCategory && categories.length < 10 && (
              <div className="category-item">
                <div
                  className="category-item-mark"
                  style={{
                    background: selectedColor || "#ccc",
                  }}
                >
                  {categories.length + 1}
                </div>
                <div
                  style={{
                    background: selectedColor ? "#00b055ff" : "none",
                  }}
                  className="category-item-active"
                >
                  {selectedColor && <img src={Check} alt="" />}
                </div>
                <input
                  type="text"
                  placeholder="Enter name"
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                  className="category-item-name-input"
                />
                <div className="category-item-btns">
                  <button onClick={handleSaveCategory}>
                    <img src={Check} alt="Save" />
                  </button>
                  <button onClick={handleCancel}>
                    <img src={DeleteIcon} alt="Cancel" />
                  </button>
                </div>
              </div>
            )}

            {/* PLUS Button */}
            {!addingCategory &&
              categories.length < 18 &&
              categories.length < 10 && (
                <button className="add-btn" onClick={handleAddCategoryClick}>
                  <img src={Plus} alt="Add Category" />
                </button>
              )}
          </div>

          {/* Right Column */}
          <div className="categories-column">
            {categories.slice(10).map((category) => (
              <div className="category-item" key={category.id}>
                <div
                  className="category-item-mark"
                  style={{
                    background: category.color,
                    color: getTextColor(category.color),
                  }}
                >
                  {category.letter}
                </div>
                <div
                  onClick={() =>
                    handleToggleActive(category.id, category.active)
                  }
                  style={{
                    background: category.active ? "#00b055ff" : "none",
                  }}
                  className="category-item-active"
                >
                  {category.active ? <img src={Check} alt="Active" /> : <></>}
                </div>

                <div className="category-item-name">
                  {editingCategoryId === category.id ? (
                    <input
                      type="text"
                      value={editingCategoryName}
                      onChange={(e) => setEditingCategoryName(e.target.value)}
                      className="category-item-name-input"
                    />
                  ) : (
                    <span>{category.name}</span>
                  )}
                </div>
                <div className="category-item-btns">
                  {editingCategoryId === category.id ? (
                    <button onClick={() => handleSaveEdit(category.id)}>
                      <img src={Check} alt="Save" />
                    </button>
                  ) : (
                    <button
                      onClick={() =>
                        handleEditCategory(category.id, category.name)
                      }
                    >
                      <img src={Edit} alt="Edit" />
                    </button>
                  )}
                  <button onClick={() => handleDeleteCategory(category.id)}>
                    <img src={DeleteIcon} alt="Delete" />
                  </button>
                </div>
              </div>
            ))}

            {/* Adding Form */}
            {addingCategory && categories.length >= 10 && (
              <div className="category-item">
                <div
                  className="category-item-mark"
                  style={{
                    background: selectedColor || "#ccc",
                  }}
                >
                  {categories.length + 1}
                </div>
                <div
                  style={{
                    background: selectedColor ? "#00b055ff" : "none",
                  }}
                  className="category-item-active"
                >
                  {selectedColor && <img src={Check} alt="" />}
                </div>
                <input
                  type="text"
                  placeholder="Enter name"
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                  className="category-item-name-input"
                />
                <div className="category-item-btns">
                  <button onClick={handleSaveCategory}>
                    <img src={Check} alt="Save" />
                  </button>
                  <button onClick={handleCancel}>
                    <img src={DeleteIcon} alt="Cancel" />
                  </button>
                </div>
              </div>
            )}

            {/* PLUS Button */}
            {!addingCategory &&
              categories.length < 18 &&
              categories.length >= 10 && (
                <button className="add-btn" onClick={handleAddCategoryClick}>
                  <img src={Plus} alt="Add Category" />
                </button>
              )}
            <div className="category-settings-item-btns">
              <button
                className="category-settings-item-btn"
                onClick={handleDiscardCategories}
              >
                <>ODUSTANI</>
              </button>
              <button
                className="category-settings-item-btn"
                onClick={handleSaveCategories}
              >
                <>POTVRDI</>
              </button>
            </div>
          </div>
        </div>

        {/* Color Palette */}
        <div className="categories-colors">
          {Array.from({ length: 6 }).map((_, rowIndex) => (
            <div
              className={`categories-color-row${rowIndex + 1}`}
              key={rowIndex}
            >
              {availableColors
                .slice(rowIndex * 3, rowIndex * 3 + 3)
                .map((color, index) => {
                  const isUsed = categories.some((cat) => cat.color === color);
                  return (
                    <button
                      key={index}
                      className="dos-btn"
                      onClick={() => !isUsed && handleSelectColor(color)}
                      disabled={isUsed}
                    >
                      <div
                        style={{
                          background: color,
                          outline:
                            selectedColor === color
                              ? "3px solid black"
                              : "none",
                          opacity: isUsed ? 0.5 : 1,
                          color: getTextColor(color), // Dynamically set text color
                        }}
                        className="color-div"
                      >
                        {categories.find((cat) => cat.color === color)
                          ?.letter || ""}
                      </div>
                    </button>
                  );
                })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Categories;
